import { Props as SelectProps } from "react-select";

import { ProfessionalCategoryEnum } from "@/utils/enums/ProfessionalCategoryEnum";
import { Option } from "@/@types/generics/Option";
import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
	noDefaultOption?: boolean;
};

export function ProfessionalCategorySelect({ noDefaultOption, ...rest }: Props) {
	const options: Option<
		(typeof ProfessionalCategoryEnum)[keyof typeof ProfessionalCategoryEnum] | null
	>[] = [
		{ label: `Todas`, value: null },
		{
			label: `Médico em geral - ${ProfessionalCategoryEnum.MEDIC_GENERIC}`,
			value: ProfessionalCategoryEnum.MEDIC_GENERIC,
		},
		{
			label: `Médico clínico - ${ProfessionalCategoryEnum.MEDIC}`,
			value: ProfessionalCategoryEnum.MEDIC,
		},
		{
			label: `Médico em especialidades cirúrgicas - ${ProfessionalCategoryEnum.MEDIC_SURGEON}`,
			value: ProfessionalCategoryEnum.MEDIC_SURGEON,
		},
		{
			label: `Médico em medicina diagnóstica e terapêutica - ${ProfessionalCategoryEnum.MEDIC_PHYSICIAN}`,
			value: ProfessionalCategoryEnum.MEDIC_PHYSICIAN,
		},
		{
			label: `Enfermeiro - ${ProfessionalCategoryEnum.NURSE}`,
			value: ProfessionalCategoryEnum.NURSE,
		},
		{
			label: `Dentista - ${ProfessionalCategoryEnum.DENTIST}`,
			value: ProfessionalCategoryEnum.DENTIST,
		},
		{
			label: `Técnico de enfermagem - ${ProfessionalCategoryEnum.NURSING_TECHNICIAN}`,
			value: ProfessionalCategoryEnum.NURSING_TECHNICIAN,
		},
	];
	return (
		<div className="d-flex flex-column">
			<label title="Categorias profissional" htmlFor={rest.id} className="mb-2">
				Categorias:
			</label>
			<SelectComponent
				className="fs-8 p-0"
				options={options}
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum perfil encontrado"}
				{...rest}
			/>
		</div>
	);
}
